import { TypedAction } from '../actions';
import { mergeObject } from '../helpers';

export function onlineOfflineReducer(state = {}, action: TypedAction) {
  switch (action.type) {
    case 'WS_MESSAGE':
      if (
        action.payload.parent_type === 'onlineoffline' &&
        action.payload.type === 'statusget'
      ) {
        const { data } = action.payload;
        return Object.entries(data).reduce(
          (s, [userId, status]) =>
            mergeObject<'onlineOffline'>(
              s,
              { status },
              { path: ['onlineOffline', userId] },
            ),
          state,
        );
      } else if (
        action.payload.parent_type === 'onlineoffline' &&
        action.payload.type === 'statuschange'
      ) {
        const { data } = action.payload;
        return mergeObject<'onlineOffline'>(
          state,
          { status: data.to },
          { path: ['onlineOffline', data.user.toString()] },
        );
      }

      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/online-offline/online-offline.reducer.ts